import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";
import { Prompt } from "./prompts.model";


export const promptsStore = createStore({ name: "prompts" }, withEntities<Prompt>(), withRequestsStatus());
